module.exports = __webpack_public_path__ + "static/media/instagram.1881f978.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/instagram.svg
// module id = 99
// module chunks = 0